// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"feeff4ea","215":"6875cb28"}[chunkId] + ".chunk.js";
};